<template>
  <modal
    class="filters-modal--adaf"
    :is-opened="isOpened"
    :on-close="onClose"
  >
    <template #header>
      <div class="filters-modal__header">
        {{ trans('modal.filters.title') }}
      </div>
    </template>
    <template #body>
      <div class="modal-state">
        <div>
          <AddressFilter class="modal-state__address-filter" />
        </div>
        <div class="modal-state__actions">
          <button class="btn btn--primary" @click="onClose">
            {{ trans('modal.filters.button') }}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@components/Modal.vue';
import AddressFilter from '@components-molecules/AddressFilter.vue';
import { translationMixin } from '@elements/translation';
import { storeToRefs } from 'pinia';
import { useAddressFilterStore } from '@stores/useAddressFilterStore';
import { eventBus } from '@tools/event-bus';
import { adafMixins } from './mixins';

export default {
  name: 'FiltersModal',
  components: { AddressFilter, Modal },
  mixins: [ translationMixin, adafMixins ],
  props: {
    isOpened: { type: Boolean, default: true },
  },
  setup() {
    const { selectedAddressesIds, selectedAddressesIdsString } = storeToRefs(useAddressFilterStore());
    return {
      selectedAddressesIds,
      selectedAddressesIdsString,
    };
  },
  data() {
    return {
      monthBeforeToday: new Date(new Date().setDate(0)),
      showDownloadOptions: false,
    };
  },
  mounted() {
    if (document.querySelector('.filters-modal .modal-container')) {
      document
        .querySelector('.filters-modal .modal-container')
        .addEventListener('click', () => {
          eventBus.dispatchEvent(new Event('filters-modal-click-outside'));
        });
    }
  },
  methods: {
    onClose() {
      this.showDownloadOptions = false;
      this.$emit('close');
    },
  },
};
</script>
